import './App.css';
import { BrowserRouter as Router , Routes , Route , useLocation } from 'react-router-dom';
import Home from './Components/Home/Home';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import AboutUs from './Components/AboutUs/AboutUs';
import Blog from './Components/Blog/Blog';
import OurServices from './Components/OurServices/OurServices';
import Contactus from './Components/Contactus/Contactus';
import React ,{useState , useEffect} from 'react';
import SingleBlog from './Components/SingleBlog/SingleBlog';
import LoaderScreen from './Components/LoaderScreen/LoaderScreen';
import ThankyouPage from './Components/ThankyouPage/ThankyouPage';
import ScrollToTop from './ScrollToTop';


const Layout = () => {

  const location = useLocation();
 
  const hideHeaderFooter = location.pathname === '/' || location.pathname === '/Thankyou';

  return (
    <>
      {!hideHeaderFooter && <Header />}
        <Routes>
          <Route exact={true} element={<Home/>} path='/Home'/>
          <Route exact={true} element={<AboutUs/>} path='/About-Us'/>
          <Route exact={true} element={<Blog/>} path='/Blogs'/>
          <Route exact={true} element={<OurServices/>} path='/Services'/>
          <Route exact={true} element={<Contactus/>} path='/ContactUs'/>
          <Route exact={true} element={<ThankyouPage/>} path='/Thankyou'/>
          <Route exact={true} element={<SingleBlog/>} path='/SingleBlog/:id'/>
          <Route exact={true} element={<LoaderScreen/>} path='/'/>
        </Routes>
        {!hideHeaderFooter && <Footer />}
    </>
  )
}

const SocialDisplayer = () => {

  
  const location = useLocation();
 
  const hideHeaderFooter = location.pathname === '/' || location.pathname === '/Thankyou';


  const [backToTop ,  setBackToTop] = useState(false)

  window.addEventListener("scroll", () => {
    if (window.pageYOffset > 300) {
      setBackToTop(true)
    }
    if(window.pageYOffset <= 20) {
      setBackToTop(false)
    }
  });


  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', 
    });
  };

  const whatsAppLinkOpener = () => {
    window.open("https://wa.me/+96895967179", "_blank");
  }


  return (
    <>
        <div className={`scroll-top-top-button duration-500 fixed bottom-6 right-5 z-[999] ${backToTop ? 'scale-100' : 'scale-0'} ${hideHeaderFooter ? 'hidden' : ''}`}>
          <button onClick={scrollToTop} className='scroll-to-top-btn w-10 h-10 rounded-full bg-BlueTheme flex items-center justify-center'>
            <i className="bi bi-arrow-up text-white text-xl"></i>
          </button>
        </div>
        <div className={`scroll-top-top-button duration-500 fixed  right-5 z-[999] ${backToTop ? 'bottom-20' : 'bottom-6'} ${hideHeaderFooter ? 'hidden' : ''}`}>
          <button onClick={whatsAppLinkOpener} className='scroll-to-top-btn w-10 h-10 rounded-full bg-green-500 flex items-center justify-center'>
            <i className="bi bi-whatsapp text-white text-xl"></i>
          </button>
        </div>
    </>
  )
}



function App() {

 
  return (
    <div className="">
      <Router>
        <ScrollToTop/>
        <Layout/>
        <SocialDisplayer/>
      </Router>
    </div>
  );
}


export default App;
